import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";
import { nexusApi } from "@/context/NexusAuthContext";
import "@/pages/nexus/nexus.css";

export default function NexusAuthVerify() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", error: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ status: "error", error: "Missing sign-in token." });
      return;
    }
    (async () => {
      try {
        const r = await nexusApi.post("/auth/magic-link/verify", { token });
        localStorage.setItem("nexus_buyer_token", r.data.token);
        const returnTo = r.data.return_to || "/nexus/deals";
        // Force a fresh mount so NexusAuthProvider re-reads the token
        window.location.replace(returnTo);
      } catch (err) {
        setState({ status: "error", error: err.response?.data?.detail || "Sign-in link could not be verified." });
      }
    })();
  }, [params, nav]);

  return (
    <div data-testid="nexus-auth-verify" className="nx-container py-24 max-w-md mx-auto">
      {state.status === "loading" ? (
        <div className="flex flex-col items-center text-center gap-4">
          <Loader2 className="animate-spin text-[#C9896E]" size={28} />
          <p className="text-white/70 font-mono text-xs uppercase tracking-[0.2em]">Verifying your sign-in link…</p>
        </div>
      ) : (
        <div className="border border-red-500/30 bg-red-500/5 p-6" data-testid="verify-error">
          <AlertCircle className="text-red-400 mb-3" size={22} />
          <div className="font-serif text-xl text-white mb-2">Sign-in link invalid</div>
          <p className="text-sm text-white/70 leading-relaxed mb-4">{state.error}</p>
          <Link to="/nexus/signin" className="text-[#C9896E] hover:text-white text-sm font-mono uppercase tracking-[0.18em]" data-testid="verify-back-to-signin">
            → Request a fresh link
          </Link>
        </div>
      )}
    </div>
  );
}
